import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import StringCell from '@/backgrid/StringCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplRelocationSummaryView from './RelocationSummaryView.hbs';

const RelocationSummaryView = View.extend({
  template: tmplRelocationSummaryView,

  className: 'relocation-summary-view',

  ui: {
    summaryTable: '.summary-table'
  },

  regions: {
    summaryTable: '@ui.summaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: '',
        sortable: false,
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'description',
        label: '',
        sortable: false,
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false
      }
    ];

    this.collection = new Backbone.Collection([
      {
        item: 'Equipment',
        description: this.model?.get('order')?.deviceMake?.concat(' ', this.model?.get('order')?.deviceModel)
      },
      {
        item: 'Moving From',
        description: this.model?.get('order')?.fromOrgUnit?.concat(' ', this.model?.get('order')?.fromBase)
      },
      {
        item: 'Relocating To',
        description: this.model?.get('order')?.toOrgUnit?.concat(' ', this.model.get('order').toBase)
      }
    ]);

    this.summaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.collection,
      columns: this.columns
    });
    this.showChildView('summaryTable', this.summaryGridView);
  }
});

export default RelocationSummaryView;
